import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";

import Button from "../../../../components/elements/Button";
import classes from "./WelcomeSection.module.scss";

type SectionCardProps = {
  icon: React.ReactNode;
  title: string;
  description: string;
  buttonTitle: string;
  buttonIcon?: React.ReactNode;
  handleClick: () => void;
};

const SectionCard: FC<SectionCardProps> = ({ icon, title, description, buttonTitle, buttonIcon, handleClick }) => {
  return (
    <div className={classes.sectionCard}>
      <div className={classes.iconWrapper}>{icon}</div>

      <div className={classes.textInfo}>
        <Typography variant="h2" className={classes.title}>
          {title}
        </Typography>
        <Typography className={classes.description}>{description}</Typography>
      </div>

      <Button fullWidth variant="outlined" onClick={handleClick}>
        {buttonTitle}
        {buttonIcon}
      </Button>
    </div>
  );
};

export default SectionCard;
